import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let FocusedInboxOption: LazyOption = createLazyOption(
    {
        key: 'focused',
        titleStringKey: 'optionTitle_focusedInbox',
        searchTermsStringKey: 'optionTitle_focusedInbox',
        allowedOptionKeys: ['FocusedInbox'],
        isHidden: () => isFeatureEnabled('tri-inbox-plus-v1'),
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default FocusedInboxOption;
